import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { DialogAbstractComponent } from '../../../../app/shared/dialogs/dialog.class';
import { AccountService } from '../../../../app/services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portal-disclaimer',
  templateUrl: './portal-disclaimer.component.html',
  styleUrls: ['./portal-disclaimer.component.scss'],
})
export class PortalDisclaimerComponent extends DialogAbstractComponent implements OnInit, OnDestroy {
  currentUser;
  constructor(injector: Injector, private accountService: AccountService, private router: Router) {
    super(injector);
  }

  async ngOnInit() {
    if (this.router.url.indexOf('dashboard') < 0 && !this.dialogParams.guestpopup) {
      this.closeDialog();
    }
  }
  ngOnDestroy() {
    this.closeDialog();
  }
  async accept() {
    try {
      await this.accountService.updatePortalDiscalimer();
      await this.accountService.loadCurrentUserFromServer();
      this.closeDialog();
    } catch (e) {}
  }

  async close() {
    if (this.dialogParams.guestpopup) {
      this.closeDialog();
      return;
    } else {
      this.currentUser = await this.accountService.currentUserAsync();
      this.router.navigate([`/dashboard`], { queryParams: { uid: `${this.currentUser.id}` } });
      this.closeDialog();
    }
  }
}
